import { FuseNavigationItem } from '@fuse/components/navigation';
import { ROLES } from '@app/constants';
import { ROLES_GROUPS } from '@app/constants';
import { Router } from '@angular/router';
import { getGlobalNavigationService } from './navigation.service';

const all = [];

const setCrmUrlFunction = (item: FuseNavigationItem, router: Router) => {
    const navigationService = getGlobalNavigationService();
    if (navigationService) {
        navigationService.setCrmUrl();
    }
};

const navigateToPremiumsCatalogueRoot = (
    _item: FuseNavigationItem,
    router: Router
) => {
    const navigationService = getGlobalNavigationService();
    if (navigationService) {
        navigationService.navigateToPremiumsCatalogueRoot();
        return;
    }

    void router.navigateByUrl('/premiums');
};

// Function that will be called from navigation
const setWarehouseUrlFunction = (item: FuseNavigationItem, router: Router) => {
    const navigationService = getGlobalNavigationService();
    if (navigationService && item.link) {
        navigationService.setWarehouseUrl(item.link);
    }
};

// Function that will be called from navigation for Logger System
const setLoggerSystemUrlFunction = (
    item: FuseNavigationItem,
    router: Router
) => {
    const navigationService = getGlobalNavigationService();
    if (navigationService && item.link) {
        navigationService.setLoggerSystemUrl(item.link);
    }
};

const setLearningSystemUrlFunction = (
    item: FuseNavigationItem,
    router: Router
) => {
    const navigationService = getGlobalNavigationService();
    if (navigationService) {
        navigationService.setLearningSystemUrl();
    }
};

const setAtcSystemUrlFunction = (item: FuseNavigationItem, router: Router) => {
    const navigationService = getGlobalNavigationService();
    if (navigationService) {
        navigationService.setAtcSystemUrl();
    }
};

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Inicio',
        type: 'basic',
        icon: 'home',
        link: '/home',
        function: setCrmUrlFunction,
        permissions: [
            ROLES.ADMINISTRATOR,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD,
            ROLES.COMPRAS,
            ROLES.COMPRAS_SR,
            ROLES.COMPRAS_SR
        ]
    },
    {
        id: 'premiums',
        title: 'Productos',
        type: 'group',
        icon: 'box',
        children: [
            {
                id: 'premiums.catalogue',
                title: 'Catálogo',
                type: 'basic',
                function: navigateToPremiumsCatalogueRoot,
                icon: 'book',
                permissions: [
                    ROLES.ADMINISTRATOR,
                    ROLES.OPERATIVO,
                    ROLES.COMPRAS,
                    ROLES.COMPRAS_SR,
                    ROLES.COMPRAS_SR,
                    ROLES.CALIDAD,
                    ROLES.PROVEEDOR,
                    ROLES.PROVEEDOR_SD
                ]
            },
            {
                id: 'premiums.orders',
                title: 'Pedidos',
                type: 'basic',
                link: '/premium-orders',
                icon: 'shopping_basket',
                permissions: [
                    ROLES.ADMINISTRATOR,
                    ROLES.OPERATIVO,
                    ROLES.COMPRAS,
                    ROLES.COMPRAS_SR,
                    ROLES.COMPRAS_SR,
                    ROLES.CALIDAD,
                    ROLES.PROVEEDOR,
                    ROLES.PROVEEDOR_SD
                ]
            },
            {
                id: 'premiums.rfqs',
                title: 'RFQ',
                type: 'basic',
                link: '/rfq/premiums/',
                icon: 'list_alt',
                permissions: [
                    ROLES.ADMINISTRATOR,
                    ROLES.OPERATIVO,
                    ROLES.COMPRAS,
                    ROLES.COMPRAS_SR,
                    ROLES.COMPRAS_SR,
                    ROLES.CALIDAD,
                    ROLES.PROVEEDOR,
                    ROLES.PROVEEDOR_SD
                ]
            }
        ]
    },
    /*
    {
        id: 'pop',
        title: 'POP',
        type: 'group',
        icon: 'shelves',
        children: [
            {
                id: 'pop.catalogue',
                title: 'Catálogo',
                type: 'basic',
                link: '/pop',
                icon: 'book',
                permissions: [
                    ROLES.ADMINISTRATOR,
                    ROLES.OPERATIVO,
                    ROLES.COMPRAS,
                    ROLES.COMPRAS_SR,
                    ROLES.COMPRAS_SR,
                    ROLES.CALIDAD,
                    ROLES.PROVEEDOR,
                    ROLES.PROVEEDOR_SD
                ]
            },
            {
                id: 'pop.orders',
                title: 'Pedidos POP',
                type: 'basic',
                link: '/pop-orders',
                icon: 'shopping_basket',
                permissions: [
                    ROLES.ADMINISTRATOR,
                    ROLES.OPERATIVO,
                    ROLES.COMPRAS,
                    ROLES.COMPRAS_SR,
                    ROLES.COMPRAS_SR,
                    ROLES.CALIDAD,
                    ROLES.PROVEEDOR,
                    ROLES.PROVEEDOR_SD
                ]
            },
            {
                id: 'pop.rfqs',
                title: 'RFQ POP',
                type: 'basic',
                link: '/rfq/pop',
                icon: 'list_alt',
                permissions: [
                    ROLES.ADMINISTRATOR,
                    ROLES.OPERATIVO,
                    ROLES.COMPRAS,
                    ROLES.COMPRAS_SR,
                    ROLES.COMPRAS_SR,
                    ROLES.CALIDAD,
                    ROLES.PROVEEDOR,
                    ROLES.PROVEEDOR_SD
                ]
            }
        ]
    },
    */
    {
        id: 'dashboard',
        title: 'Dashboard',
        link: '/dashboard/premiums',
        icon: 'space_dashboard',
        type: 'basic',
        permissions: [
            ROLES.ADMINISTRATOR,
            ROLES.OPERATIVO,
            ROLES.COMPRAS,
            ROLES.COMPRAS_SR,
            ROLES.PROVEEDOR,
            ROLES.PROVEEDOR_SD
        ]
    },
    {
        id: 'automobiles',
        title: 'Autos',
        type: 'basic',
        icon: 'directions_car',
        link: '/automobiles',
        permissions: [
            ROLES.ADMINISTRATOR,
            ROLES.OPERATIVO,
            ROLES.COMPRAS,
            ROLES.COMPRAS_SR,
            ROLES.COMPRAS_SR,
            ROLES.CALIDAD,
            ROLES.PUBLIC
        ]
    },
    {
        id: 'warehouse',
        title: 'WMS',
        type: 'basic',
        icon: 'warehouse',
        link: '/external/wms/home',
        function: setWarehouseUrlFunction,
        permissions: [ROLES.ADMINISTRATOR, ROLES.LOGISTIC]
    },
    {
        id: 'logger-system',
        title: 'Logger System',
        type: 'basic',
        icon: 'description',
        link: '/external/logger-system/home',
        function: setLoggerSystemUrlFunction,
        permissions: [ROLES.ADMINISTRATOR, ROLES.LOGISTIC]
    },
    {
        id: 'learning-system',
        title: 'Learning System',
        type: 'basic',
        icon: 'school',
        link: '/external/learning-system',
        function: setLearningSystemUrlFunction,
        permissions: [ROLES.ADMINISTRATOR]
    },
    {
        id: 'atc-system',
        title: 'ATC System',
        type: 'basic',
        icon: 'support_agent',
        link: '/external/atc-system',
        function: setAtcSystemUrlFunction,
        permissions: [ROLES.ADMINISTRATOR]
    },
    /*{
        title: '¿Necesitas ayuda?',
        link: '/help',
        icon: 'help',
        type: 'basic',
        permissions: [
            ROLES.ADMINISTRATOR,
            ROLES.COMPRAS,
            ROLES.COMPRAS_SR,
            ROLES.RH,
            ROLES.CALIDAD,
            ROLES.PROVEEDOR
        ]
    },
    {
        title: 'Configuración',
        link: '/providers/settings',
        icon: 'settings',
        type: 'basic',
        permissions: [ROLES.PROVEEDOR]
    },*/
    {
        id: 'admin',
        title: 'Admin',
        icon: 'settings',
        type: 'group',
        children: [
            {
                title: 'Usuarios',
                link: '/admin/users',
                icon: 'people',
                type: 'basic',
                permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO]
            },
            {
                title: 'Clientes',
                link: '/admin/clients',
                icon: 'business_center',
                type: 'basic',
                permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO]
            },
            {
                title: 'Proveedores',
                link: '/admin/providers',
                icon: 'storefront',
                type: 'basic',
                permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO]
            },
            {
                title: 'Premiums',
                link: '/admin/catalogue/premiums',
                icon: 'box',
                type: 'collapsable',
                permissions: [
                    ROLES.ADMINISTRATOR,
                    ROLES.OPERATIVO,
                    ROLES.PROVEEDOR_SD
                ],
                children: [
                    {
                        title: 'Categorías',
                        icon: 'apps',
                        link: '/admin/catalogue/premiums/categories',
                        type: 'basic',
                        permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO]
                    },
                    {
                        title: 'APIs',
                        icon: 'grid_view',
                        link: '/admin/catalogue/premiums/apis',
                        type: 'basic',
                        permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO]
                    },
                    {
                        title: 'Marcas',
                        icon: 'brand_family',
                        link: '/admin/catalogue/premiums/brands',
                        type: 'basic',
                        permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO]
                    },
                    {
                        title: 'Inteligencia artificial',
                        icon: 'online_prediction',
                        type: 'collapsable',
                        permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO],
                        children: [
                            {
                                title: 'Product labels',
                                icon: 'category',
                                link:
                                    '/admin/catalogue/premiums/ai/product-labels',
                                type: 'basic'
                            },
                            {
                                title: 'Product texts',
                                icon: 'abc',
                                link:
                                    '/admin/catalogue/premiums/ai/product-texts',
                                type: 'basic'
                            }
                        ]
                    },
                    {
                        title: 'Máscaras',
                        icon: 'domino_mask',
                        type: 'collapsable',
                        permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO],
                        children: [
                            {
                                title: 'Generación masiva',
                                icon: 'cloud_sync',
                                link:
                                    '/admin/catalogue/premiums/masks/massive-masks',
                                type: 'basic'
                            },
                            {
                                title: 'Por categoría',
                                icon: 'apps',
                                link:
                                    '/admin/catalogue/premiums/masks/categories',
                                type: 'basic'
                            },
                            {
                                title: 'Por cliente',
                                icon: 'business_center',
                                link: '/admin/catalogue/premiums/masks/clients',
                                type: 'basic'
                            },
                            {
                                title: 'Por producto',
                                icon: 'inventory_2',
                                link:
                                    '/admin/catalogue/premiums/masks/products',
                                type: 'basic'
                            }
                        ]
                    },
                    {
                        title: 'Carga masiva',
                        icon: 'cloud_upload',
                        link: '/admin/catalogue/premiums/massive-charge',
                        type: 'basic',
                        permissions: [
                            ROLES.ADMINISTRATOR,
                            ROLES.OPERATIVO,
                            ROLES.PROVEEDOR_SD
                        ]
                    },
                    {
                        title: 'Actualización masiva',
                        icon: 'dynamic_form',
                        link: '/admin/catalogue/premiums/massive-update',
                        type: 'basic',
                        permissions: [
                            ROLES.ADMINISTRATOR,
                            ROLES.OPERATIVO,
                            ROLES.PROVEEDOR,
                            ROLES.PROVEEDOR_SD,
                            ROLES.PROVEEDOR_API
                        ]
                    },
                    {
                        title: 'Pangga',
                        icon: 'sell',
                        link: '/admin/catalogue/premiums/pangga/products',
                        type: 'basic',
                        permissions: [
                            ROLES.ADMINISTRATOR,
                            ROLES.OPERATIVO,
                            ROLES.PROVEEDOR_SD
                        ]
                    },
                    {
                        title: 'Precios de impresión',
                        icon: 'money',
                        link: '/admin/catalogue/premiums/print-prices',
                        type: 'basic',
                        permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO]
                    },
                    {
                        title: 'Procesos premium',
                        icon: 'settings',
                        link: '/admin/settings/processes/premium',
                        type: 'basic',
                        permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO]
                    },
                    {
                        title: 'Cupones',
                        icon: 'local_offer',
                        link: '/admin/catalogue/premiums/coupons',
                        type: 'basic',
                        permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO]
                    },
                    {
                        title: 'Promociones',
                        icon: 'redeem',
                        link: '/admin/catalogue/premiums/promotions',
                        type: 'basic',
                        permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO]
                    },
                    {
                        title: 'Búsqueda',
                        icon: 'search',
                        link: '/admin/catalogue/premiums/search/term/products',
                        type: 'basic',
                        permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO]
                    }
                ]
            },
            /*
            {
                title: 'POP',
                link: '/admin/catalogue/pop',
                icon: 'shelves',
                type: 'collapsable',
                permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO],
                children: [
                    {
                        title: 'Materiales POP',
                        icon: 'apps',
                        link: '/admin/catalogue/premiums/categories',
                        type: 'basic'
                    },
                    {
                        title: 'Procesos POP',
                        icon: 'settings',
                        link: '/admin/settings/processes/pop',
                        type: 'basic'
                    }
                ]
            },
            {
                title: 'Impresos',
                link: '/admin/catalogue/printed',
                icon: 'inventory_2',
                type: 'collapsable',
                permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO],
                children: [
                    {
                        title: 'Categorías impresos',
                        icon: 'apps',
                        link: '/admin/catalogue/printed/categories',
                        type: 'basic'
                    },
                    {
                        title: 'Procesos Impresos',
                        icon: 'settings',
                        link: '/admin/settings/processes/printed',
                        type: 'basic'
                    }
                ]
            },
            {
                title: 'Alendum',
                link: '/admin/settings/alendum',
                icon: 'api',
                type: 'collapsable',
                children: [
                    {
                        title: 'Clientes (Terceros)',
                        icon: 'domain',
                        link: '/admin/settings/alendum/clients',
                        type: 'basic',
                        permissions: [ROLES.ADMINISTRATOR]
                    },
                    {
                        title: 'Direcciones',
                        icon: 'location_on',
                        link: '/admin/settings/alendum/addresses',
                        type: 'basic',
                        permissions: [ROLES.ADMINISTRATOR]
                    },
                    {
                        title: 'Pedidos de venta',
                        icon: 'request_page',
                        link: '/admin/settings/alendum/sales-orders',
                        type: 'basic',
                        permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO]
                    },
                    {
                        title: 'Usuarios',
                        icon: 'group',
                        link: '/admin/settings/alendum/users',
                        type: 'basic',
                        permissions: [ROLES.ADMINISTRATOR]
                    },

                    {
                        title: 'Productos',
                        icon: 'local_mall',
                        type: 'collapsable',
                        children: [
                            {
                                title: 'Productos Alendum',
                                icon: 'database',
                                link: '/admin/settings/alendum/products',
                                type: 'basic'
                            },
                            {
                                title: 'Productos nuevos',
                                icon: 'new_releases',
                                link:
                                    '/admin/settings/alendum/brand-factory/products/new-products',
                                type: 'basic'
                            },
                            {
                                title: 'Productos sincronizados',
                                icon: 'sync',
                                link:
                                    '/admin/settings/alendum/brand-factory/products/linked-products',
                                type: 'basic'
                            },
                            {
                                title: 'Productos descontinuados',
                                icon: 'warning',
                                link:
                                    '/admin/settings/alendum/brand-factory/products/discontinued-products',
                                type: 'basic'
                            }
                        ],
                        permissions: [
                            ROLES.ADMINISTRATOR,
                            ROLES.OPERATIVO,
                            ROLES.PROVEEDOR_SD
                        ]
                    },
                    {
                        title: 'Catálogos Alendum',
                        icon: 'apps',
                        type: 'collapsable',
                        children: [
                            {
                                title: 'Tarifa de precios',
                                icon: 'paid',
                                link: '/admin/settings/alendum/price-rates',
                                type: 'basic'
                            },
                            {
                                title: 'Organizaciones',
                                icon: 'corporate_fare',
                                link: '/admin/settings/alendum/organizations',
                                type: 'basic'
                            },
                            {
                                title: 'Grupos de terceros',
                                icon: 'groups',
                                link: '/admin/settings/alendum/third-groups',
                                type: 'basic'
                            },
                            {
                                title: 'Métodos de pago',
                                icon: 'credit_card',
                                link: '/admin/settings/alendum/payment-methods',
                                type: 'basic'
                            },
                            {
                                title: 'Condiciones de pago',
                                icon: 'receipt_long',
                                link:
                                    '/admin/settings/alendum/payment-conditions',
                                type: 'basic'
                            },
                            {
                                title: 'Cuentas financieras',
                                icon: 'account_balance_wallet',
                                link:
                                    '/admin/settings/alendum/financial-accounts',
                                type: 'basic'
                            },
                            {
                                title: 'Impuestos de terceros',
                                icon: 'account_balance',
                                link:
                                    '/admin/settings/alendum/third-party-taxes',
                                type: 'basic'
                            },
                            {
                                title: 'Representantes de ventas',
                                icon: 'support_agent',
                                link:
                                    '/admin/settings/alendum/sales-representatives',
                                type: 'basic'
                            },
                            {
                                title: 'Países y estados',
                                icon: 'flag',
                                link:
                                    '/admin/settings/alendum/countries-and-states',
                                type: 'basic'
                            },
                            {
                                title: 'Regimen Fiscal',
                                icon: 'layers',
                                link: '/admin/settings/alendum/tax-regimes',
                                type: 'basic'
                            },
                            {
                                title: 'Uso CDFI',
                                icon: 'payments',
                                link: '/admin/settings/alendum/cfdi-uses',
                                type: 'basic'
                            },
                            {
                                title: 'Rangos de impuestos',
                                icon: 'trending_up',
                                link: '/admin/settings/alendum/tax-ranges',
                                type: 'basic'
                            },
                            {
                                title: 'Almacenes y Espacios',
                                icon: 'inventory_2',
                                link:
                                    '/admin/settings/alendum/warehouses-and-spaces',
                                type: 'basic'
                            },
                            {
                                title: 'Tipos de Documento',
                                icon: 'description',
                                link: '/admin/settings/alendum/document-types',
                                type: 'basic'
                            },
                            {
                                title: 'Monedas',
                                icon: 'paid',
                                link: '/admin/settings/alendum/currencies',
                                type: 'basic'
                            }
                        ],
                        permissions: [ROLES.ADMINISTRATOR]
                    },
                    {
                        title: 'Catálogos Medi Commerce',
                        icon: 'grid_view',
                        type: 'collapsable',
                        children: [
                            {
                                title: 'Categorías Alendum',
                                icon: 'checklist',
                                link:
                                    '/admin/settings/alendum/brand-factory/alendum-categories',
                                type: 'basic'
                            },
                            {
                                title: 'Categorías Medi Commerce',
                                icon: 'format_list_bulleted',
                                link:
                                    '/admin/settings/alendum/brand-factory/alendum-bf-categories',
                                type: 'basic'
                            }
                        ],
                        permissions: [ROLES.ADMINISTRATOR]
                    }
                ],
                permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO]
            },

            {
                title: 'Productos Alendum',
                icon: 'local_mall',
                type: 'collapsable',
                children: [
                    {
                        title: 'Productos Alendum',
                        icon: 'database',
                        link: '/admin/settings/alendum/products',
                        type: 'basic'
                    }
                ],
                permissions: [ROLES.PROVEEDOR_SD]
            },*/

            {
                title: 'Logística',
                link: '/admin/settings/logistic',
                icon: 'local_shipping',
                type: 'collapsable',
                permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO],
                children: [
                    {
                        title: 'Medi Commerce',
                        icon: 'apartment',
                        type: 'collapsable',
                        children: [
                            {
                                title: 'Cajas',
                                icon: 'deployed_code',
                                link:
                                    '/admin/settings/logistic/brand-factory/boxes',
                                type: 'basic'
                            },
                            {
                                title: 'Rangos de piezas',
                                icon: 'stacks',
                                link:
                                    '/admin/settings/logistic/brand-factory/pieces-ranges',
                                type: 'basic'
                            },
                            {
                                title: 'Rangos de peso',
                                icon: 'weight',
                                link:
                                    '/admin/settings/logistic/brand-factory/weight-ranges',
                                type: 'basic'
                            },
                            {
                                title: 'Códigos postales',
                                icon: 'local_post_office',
                                link:
                                    '/admin/settings/logistic/brand-factory/postal-codes',
                                type: 'basic'
                            },
                            {
                                title: 'Zonas geográficas',
                                icon: 'map',
                                link:
                                    '/admin/settings/logistic/brand-factory/zones',
                                type: 'basic'
                            }
                        ]
                    },
                    {
                        title: 'Pak Mail',
                        icon: 'package_2',
                        type: 'collapsable',
                        children: [
                            {
                                title: 'Paqueterías',
                                icon: 'package_2',
                                link:
                                    '/admin/settings/logistic/pak-mail/carriers',
                                type: 'basic'
                            },
                            {
                                title: 'Estatus de envío',
                                icon: 'local_shipping',
                                link:
                                    '/admin/settings/logistic/pak-mail/shipment-statuses',
                                type: 'basic'
                            },
                            {
                                title: 'Estatus de recolección',
                                icon: 'sync_alt',
                                link:
                                    '/admin/settings/logistic/pak-mail/pickup-statuses',
                                type: 'basic'
                            }
                        ]
                    },
                    {
                        title: 'Big Smart',
                        icon: 'local_shipping',
                        link: '/admin/settings/processes/big-smart',
                        type: 'basic'
                    }
                ]
            },
            {
                title: 'Home page',
                link: '/admin/settings/home-page',
                icon: 'real_estate_agent',
                type: 'collapsable',
                permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO],
                children: [
                    {
                        title: 'Carrusel',
                        icon: 'view_carousel',
                        link: '/admin/settings/home-page/carousel',
                        type: 'basic'
                    },
                    {
                        title: 'Wall',
                        icon: 'wallpaper',
                        link: '/admin/settings/home-page/wall',
                        type: 'basic'
                    },
                    {
                        title: 'Banner',
                        icon: 'panorama',
                        link: '/admin/settings/home-page/banner',
                        type: 'basic'
                    }
                ]
            },
            {
                title: 'Landing Medi-Commerce',
                icon: 'web',
                type: 'collapsable',
                permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO],
                children: [
                    {
                        title: 'Banner principal',
                        icon: 'image',
                        link: '/admin/landing/hero',
                        type: 'basic'
                    },
                    {
                        title: 'Categorías destacadas',
                        icon: 'category',
                        link: '/admin/landing/category-highlights',
                        type: 'basic'
                    },
                    {
                        title: 'Audiencias',
                        icon: 'groups',
                        link: '/admin/landing/audience-blocks',
                        type: 'basic'
                    },
                    {
                        title: 'Problema y solución',
                        icon: 'compare_arrows',
                        link: '/admin/landing/problem-solution',
                        type: 'basic'
                    },
                    {
                        title: 'Métricas',
                        icon: 'analytics',
                        link: '/admin/landing/metrics',
                        type: 'basic'
                    },
                    {
                        title: 'Pasos del proceso',
                        icon: 'format_list_numbered',
                        link: '/admin/landing/process-steps',
                        type: 'basic'
                    }
                ]
            },
            {
                title: 'CRM',
                icon: 'patient_list',
                link: '/external/crm',
                type: 'collapsable',
                permissions: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO],
                children: [
                    {
                        title: 'Clientes',
                        icon: 'lists',
                        link: '/external/crm-admin-clients',
                        type: 'basic'
                    },
                    {
                        title: 'Proveedores',
                        icon: 'lists',
                        link: '/external/crm-admin-providers',
                        type: 'basic'
                    },
                    {
                        title: 'Carga masiva',
                        icon: 'manufacturing',
                        link: '/external/crm-massive-charge',
                        type: 'basic'
                    },
                    {
                        title: 'Celulas de trabajo',
                        icon: 'cell',
                        link: '/external/crm-admin-cells',
                        type: 'basic'
                    },
                    {
                        title: "KPI's",
                        icon: 'analytics',
                        link: '/external/crm-admin-kpis',
                        type: 'basic',
                        permissions: [ROLES.ADMINISTRATOR]
                    },
                    {
                        title: 'Configuración global',
                        icon: 'settings',
                        link: '/external/crm-global-config',
                        type: 'basic',
                        permissions: [ROLES.ADMINISTRATOR]
                    }
                ]
            }
        ]
    },
    {
        title: 'Actualización masiva',
        icon: 'dynamic_form',
        link: '/admin/catalogue/premiums/massive-update',
        type: 'basic',
        permissions: [ROLES.PROVEEDOR_API]
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Inicio',
        type: 'basic',
        icon: 'home',
        link: '/home'
    },
    {
        id: 'premiums',
        title: 'Premiums',
        type: 'group',
        icon: 'box',
        children: []
    },
    {
        id: 'editar-info',
        title: 'Editar información',
        type: 'basic',
        icon: 'edit',
        link: '/admin/settings/provider/info',
        permissions: ROLES_GROUPS.ORDER_GROUP
    },
    {
        id: 'pop',
        title: 'POP',
        type: 'group',
        icon: 'shelves',
        children: []
    },
    {
        id: 'printed',
        title: 'Impresos',
        type: 'group',
        icon: 'inventory_2',
        children: []
    },
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'space_dashboard',
        link: '/dashboard/premiums',
        permissions: [ROLES.ADMINISTRATOR]
    },
    {
        id: 'admin',
        title: 'Admin',
        type: 'group',
        icon: 'settings',
        children: []
    }
];
